module.exports = function ($, M, i18n) {
  var options = {
    showKeyIfEmpty: true,
    // languages
    lng: M.LANG,
    load: 'current',
    // prevent loading multiple json files
    fallbackLng: false,
    // separators
    keyseparator: '&&&&&',
    nsseparator: '&&&&&&',
    // resource store
    resGetPath: M.STATIC_URL + M.urls.locale,
  };

  // shortcut
  window._t = i18n.t;
  window.plural = require('plugins/i18n/pluralise')(sprintf);

  return callback => {
    i18n.init(options, function () {
      // trigger callback passed to this function, if it exists
      if (callback) {
        callback();
      }

      $(document).ready(function () {
        if (M.renderer) {
          M.renderer.load(M.templates);
        }
      });
    });
  };
};
